// pages/LoginRequired.jsx
import React from 'react';
import {Link} from 'react-router-dom';
import {useAuth} from '../hooks/useAuth';
import {useLoginModal} from '../contexts/LoginModalContext';
import LoginModal from '../components/loginModal';

const LoginRequired = () => {
    const {user} = useAuth();
    const {isLoginModalOpen, openLoginModal, closeLoginModal, handleLoginSuccess} = useLoginModal();
    
    const handleLoginClick = () => {
        openLoginModal();
    };

    return (
        <div className="min-h-screen bg-gray-50 pt-20 px-4">
            <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg p-8 text-center">
                <div className="mb-6">
                    {user ? (
                        <div className="w-20 h-20 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4">
                            <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5.121 17.804A9 9 0 1118.879 6.196 9 9 0 015.121 17.804zM15 11l-3-3m0 0l-3 3m3-3v8"></path>
                            </svg>
                        </div>
                    ) : (
                        <div className="w-20 h-20 mx-auto bg-yellow-100 rounded-full flex items-center justify-center mb-4">
                            <svg className="w-10 h-10 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m0 0v2m0-2h2m-2 0H9m3-10v6m0 0l-3-3m3 3l3-3"/>
                            </svg>
                        </div>
                    )}
                    
                    <h1 className="text-2xl font-bold text-gray-800 mb-2">
                        {user ? "Access Denied" : "Login Required"}
                    </h1>

                    <p className="text-gray-600 mb-6">
                        {user ? "You don't have permission to access this page." : "Please login to access this feature."}
                    </p>
                </div>

                <div className="space-y-4">
                    {!user && (
                        <>
                            <button onClick={handleLoginClick}
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200">
                                Login to Continue
                            </button>

                            <div className="relative my-6">
                                <div className="absolute inset-0 flex items-center">
                                    <div className="w-full border-t border-gray-300"></div>
                                </div>
                                <div className="relative flex justify-center text-sm">
                                    <span className="px-2 bg-white text-gray-500">New to our platform?</span>
                                </div>
                            </div>

                            <button onClick={handleLoginClick}
                                className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-3 px-4 rounded-lg transition duration-200 text-center">
                                Create New Account
                            </button>
                        </>
                    )}

                    <Link to="/" className="block w-full border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold py-3 px-4 rounded-lg transition duration-200 text-center">
                        ← Back to Home
                    </Link>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                        Need help? {' '}
                        <Link to="/contact-us" className="text-blue-600 hover:text-blue-800 ml-1">Contact Support</Link>
                    </p>
                </div>
            </div>
            <LoginModal 
                isOpen={isLoginModalOpen}
                onClose={closeLoginModal}
            />
        </div>
    );
};

export default LoginRequired;